import React from 'react';
import { ContentState, ContentBlock } from 'draft-js';

// Components
import { WpGif } from '../../../../gif';

// Styles
import './GifComponent.scss';

type GifComponentProps = {
  contentState: ContentState;
  block: ContentBlock;
};

const GifComponent = ({ block, contentState }: GifComponentProps) => {
  const { src } = contentState.getEntity(block.getEntityAt(0)).getData();

  return (
    <div className="GifComponent">
      <WpGif url={src} />
    </div>
  );
};

export default GifComponent;
